import { render } from "./Pricing.vue?vue&type=template&id=c20369e4&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=c20369e4&scoped=true&lang=css"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20369e4"]])

export default __exports__